<template>
    <div class="container fluid">
        <div class="row">
            <div class="col-12 col-md-7">
                <content-navigation :titles="topNav"/>
                <div class="announce">
                    <p class="announce-inner">
                        Индивидуальный проект учитывает 100% ваших пожеланий и разрабатывается только для вас!
                    </p>
                </div>
                <template v-if="loaded">
                    <local-title>
                        <template slot="title">Преимущества индивидуального проектирования:</template>
                    </local-title>

                    <list-item :logo="url + '/img/logos/1_ind_up.png'">
                        <template slot="text">
                            <div v-html="loadedText('individual-advantage1')"></div>
                        </template>
                    </list-item>
                    <list-item :logo="url + '/img/logos/2_ind_up.png'">
                        <template slot="text">
                            <div v-html="loadedText('individual-advantage2')"></div>
                        </template>
                    </list-item>
                    <list-item :logo="url + '/img/logos/3_ind_up.png'">
                        <template slot="text">
                            <div v-html="loadedText('individual-advantage3')"></div>
                        </template>
                    </list-item>
                    <br/>
                    <local-title>
                        <template slot="title">Что включает в себя инивидуальный проект дома:</template>
                    </local-title>

                    <list-item :logo="url + '/img/logos/4_esk_up.png'">
                        <template slot="top">
                            1. Эскизный проект.
                        </template>
                        <template slot="text">
                            <div v-html="loadedText('individual-sketch1')"></div>
                        </template>
                        <template slot="bottom">
                            <div class="bottom-item">
                                <div v-html="loadedText('individual-sketch-price')"></div>
                            </div>
                        </template>
                    </list-item>

                    <list-item :logo="url + '/img/logos/5_esk_up.png'">
                        <template slot="top">
                            2. Рабочий проект.
                        </template>
                        <template slot="text">
                            <div v-html="loadedText('individual-draft1')"></div>
                        </template>
                    </list-item>

                    <list-item :logo="url + '/img/logos/6_esk_up.png'">
                        <template slot="text">
                            <div v-html="loadedText('individual-draft2')"></div>
                        </template>
                        <template slot="bottom">
                            <div class="bottom-item">
                                <div v-html="loadedText('individual-draft-price')"></div>
                            </div>
                        </template>
                    </list-item>
                    <br/>
                    <local-title>
                        <template slot="title">Дополнительно могут быть заказаны:</template>
                    </local-title>

                    <list-item :logo="url + '/img/logos/7_extra.png'">
                        <template slot="top">
                            <p class="extra-title">1. Инжернерные разделы.</p>
                            <p class="extra-p">Разделы ВК (Водопровод и канализация),</p>
                            <p class="extra-p">ОВ (Отопление и вентиляция),</p>
                            <p class="extra-p">ЭО (Электрооборудование).</p>
                        </template>
                        <template slot="bottom">
                            <div class="bottom-item">
                                <div v-html="loadedText('individual-extra-price-1')"></div>
                            </div>
                        </template>
                    </list-item>

                    <list-item :logo="url + '/img/logos/8_extra.png'">
                        <template slot="top">
                            <p class="extra-p">2. Проект благоустройства и озеленения участка (Ландшафтный дизайн).</p>
                        </template>
                        <template slot="bottom">
                            <div class="bottom-item">
                                <div v-html="loadedText('individual-extra-price-2')"></div>
                            </div>
                        </template>
                    </list-item>

                    <list-item :logo="url + '/img/logos/9_extra.png'">
                        <template slot="top">
                            <p class="extra-p">3. Дизайн-проект интерьеров.</p>
                        </template>
                        <template slot="bottom">
                            <div class="bottom-item">
                                <div v-html="loadedText('individual-extra-price-3')"></div>
                            </div>
                        </template>
                    </list-item>
                    <br/>
                    <p class="bottom-info">Стоимость проектирования зависит от сложности задачния и площади дома.</p>
                    <p class="bottom-info">Проектная документация передаётся Заказчику на бумажном носителе в двух
                        экземплярах. В электронном виде, в формате AutoCad - в объёме, необходимом для разработки
                        инженерных сетей и дизайн-пректа интерьера.</p>
                </template>
                <div v-else>
                    <preloader></preloader>
                </div>
            </div>
            <div class="d-none d-md-flex col-md-5">
                <vertical-photo-wrapper :photos="photosToDisplay"></vertical-photo-wrapper>
            </div>
        </div>

    </div>
</template>
<script>
import ContentNavigation from "../components/General/ContentNavigation";
import VerticalPhotoWrapper from "../components/General/VerticalPhotoWrapper";
import LocalTitle from "../components/General/LocalTitle";
import ListItem from "../components/General/ListItem";
import Preloader from "../components/General/Preloader";
export default {
    data() {
        return {
            topNav: [
                {
                    title: "Главная",
                    routeName: "home",
                },
                {
                    title: "Индивидуальные проекты",
                    routeName: null,
                },
            ],
            photosToDisplay: [],
            url: process.env.VUE_APP_URL,
        };
    },
    components: {
        ContentNavigation, VerticalPhotoWrapper, LocalTitle, ListItem, Preloader
    },
    methods: {
        getPhotosToDisplay() {
            let baseName = process.env.VUE_APP_URL + "/img/photos/individual/";
            for (let i = 1; i <= 5; i++)
                this.photosToDisplay.push(baseName + i + ".jpg");
        },
    },
    computed: {
        loaded(){
            return this.$store.getters["pages/loaded"]("individual-projects")
        },
        loadedText: function () {
            let vm = this;
            return function (code) {
                const text = vm.$store.getters["pages/byCode"](code)
                return text || ""
            }
        },
    },
    created() {
        this.$store.dispatch("pages/load", "individual-projects");

        this.$store.commit("navigation/SET_CURRENT_STATE", "indi")
        this.getPhotosToDisplay();
    },
};
</script>

<style scoped>
    .announce-inner{
        font-size: 26px;
        text-align: justify;
        line-height: 30px;
    }
    .announce{
        margin: 30px 0 35px;
    }
    .bottom-item{
        margin-top: 10px;
        margin-bottom: 0
    }
    .extra-p{
        margin-top: 0;
        margin-bottom: 0
    }
    .bottom-info{
        font-size: 16px;
        line-height: 20px;
    }
</style>
